"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLUGIN_STATUS = void 0;
exports.PLUGIN_STATUS = {
    ACTIVE: 'ACTIVE',
    DEACTIVATED: 'DEACTIVATED'
};
//# sourceMappingURL=pluginStatus.js.map